var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUpFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M571.305-123.652v-69.463q96.435-28.45 158.217-107.668Q791.305-380 791.305-481q0-101-61.283-180.717-61.282-79.718-158.717-107.168v-69.463q126.39 28.423 206.304 128.255T857.523-481q0 129.261-79.914 229.093T571.305-123.652ZM102.477-345.869v-268.827h168.479L491.305-834.48v708.96L270.956-345.869H102.477Zm448.828 38.956v-347.174q56.696 18.696 91.457 66.305 34.761 47.61 34.761 107.82 0 59.223-35.261 107.071t-90.957 65.978Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/volume_up-fill-9085514e.svg";
export { SvgVolumeUpFill as ReactComponent };